import { render, staticRenderFns } from "./ManagingPrincipalRevenue.vue?vue&type=template&id=2fcd2c1d&scoped=true"
import script from "./ManagingPrincipalRevenue.vue?vue&type=script&lang=js"
export * from "./ManagingPrincipalRevenue.vue?vue&type=script&lang=js"
import style0 from "./ManagingPrincipalRevenue.vue?vue&type=style&index=0&id=2fcd2c1d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcd2c1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fcd2c1d')) {
      api.createRecord('2fcd2c1d', component.options)
    } else {
      api.reload('2fcd2c1d', component.options)
    }
    module.hot.accept("./ManagingPrincipalRevenue.vue?vue&type=template&id=2fcd2c1d&scoped=true", function () {
      api.rerender('2fcd2c1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/ManagingPrincipalRevenue.vue"
export default component.exports